import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const MY_CHOICE_KEYBOARDING_ACTIVITY_FRAGMENT = gql `
  fragment MyChoiceKeyboardingActivityFragment on MyChoiceKeyboardingActivity {
    rounds {
      instructions
      myChoiceInstructionsAudio: instructionsAudio {
        audio {
          ...AssetFragment
        }
      }
      myChoiceAudio: optionalAudio {
        audio {
          ...AssetFragment
        }
      }
      myChoiceImage: optionalImage {
        image {
          ...AssetFragment
        }
      }
      myChoiceQuestion: optionalQuestion
      questionType
    }
  }
  ${ASSET_FRAGMENT}
`;
export default MY_CHOICE_KEYBOARDING_ACTIVITY_FRAGMENT;
